// import '@capacitor-community/http';
import { BluetoothSerial } from '@awesome-cordova-plugins/bluetooth-serial';
import { IonAlert, IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonModal, IonPage, IonSelect, IonSelectOption, IonTitle, IonToast, IonToggle, IonToolbar, isPlatform, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { arrowBack } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { adicionarImpressaoNaFila, criarJobImpressao } from '../../../../../Utils/PrintQueueHelper';
import { empresaAlterar, empresaConfiguracoesCarregar, onboardingAtualizarEtapa, requestService } from '../../../../../Utils/Services';
import OnboardingContextBanner from '../../../../../components/Onboarding/OnboardingContextBanner';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { OnboardingContext } from '../../../../../contexts/OnboardingContext';
import Bluetooth from '../Bluetooth/Bluetooth';
import BluetoothSPP from '../BluetoothSPP/BluetoothSPP';
import './Impressao.css';
import ModalMultiImpressao from './ModalMultiImpressao';

type Props = {
  abrirMenu: boolean;
};

const Impressao: React.FC<Props> = (props: Props) => {

  const history = useHistory();

  const [showToast2, setShowToast2] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const [showLoading, setShowLoading] = useState(true);
  const [showSucesso, setShowSucesso] = useState(false);

  const { loja, setLoja } = useContext(MessageContext);
  const { onboardingData, setOnboardingData } = useContext(OnboardingContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const [impressoraLargura, setImpressoraLargura] = useState('');

  const [impressoraLocalHabilitar, setImpressoraLocalHabilitar] = useState<boolean>(false);
  const [impressoraLocalName, setImpressoraLocalName] = useState('');
  const [impressorasLocal, setImpressorasLocal] = useState<string[]>([]);

  const [impressoraRedeHabilitar, setImpressoraRedeHabilitar] = useState<boolean>(false);
  const [impressoraRedeIp, setImpressoraRedeIp] = useState('');
  const [impressoraRedePorta, setImpressoraRedePorta] = useState('');

  const [impressoraBluetoothHabilitar, setImpressoraBluetoothHabilitar] = useState<boolean>(false);
  const [impressoraBluetoothDeviceId, setImpressoraBluetoothDeviceId] = useState('');
  const [impressoraBluetoothName, setImpressoraBluetoothName] = useState('');

  // Bluetooth SPP (Serial Port Profile) - Somente Android
  const [impressoraBluetoothSPPHabilitar, setImpressoraBluetoothSPPHabilitar] = useState<boolean>(false);
  const [impressoraBluetoothSPPAddress, setImpressoraBluetoothSPPAddress] = useState('');
  const [impressoraBluetoothSPPName, setImpressoraBluetoothSPPName] = useState('');

  const [impressaoAutomatica, setImpressaoAutomatica] = useState<boolean>(false);
  const [impressaoAutomaticaIfood, setImpressaoAutomaticaIfood] = useState<boolean>(false);
  const [impressaoDuasVias, setImpressaoDuasVias] = useState<boolean>(false);
  const [multiImpressao, setMultiImpressao] = useState<number>(1);

  // Multi impressão - Impressoras adicionais (estrutura aninhada)
  const [impressorasAdicionais, setImpressorasAdicionais] = useState<Array<{
    nome: string;
    conexoes: Array<{
      tipo: 'local' | 'rede' | 'ble' | 'spp';
      localName?: string;            // Configuração Desktop
      redeIp?: string;               // Configuração Mobile - Rede
      redePorta?: string;            // Configuração Mobile - Rede
      bluetoothDeviceId?: string;    // Configuração Mobile - Bluetooth BLE
      bluetoothSPPAddress?: string;  // Configuração Mobile - Bluetooth SPP (Android)
    }>;
  }>>([]);

  // Armazena as impressoras originais do banco para mesclar ao salvar
  const [impressorasAdicionaisOriginais, setImpressorasAdicionaisOriginais] = useState<Array<any>>([]);

  // Estado para rastrear qual impressora adicional está sendo configurada
  const [impressoraAdicionalEmConfiguracao, setImpressoraAdicionalEmConfiguracao] = useState<number | null>(null);

  const [imprimirMesaParcial, setImprimirMesaParcial] = useState<boolean>(false);
  const [tamanhoFonte, setTamanhoFonte] = useState<string>('normal');

  const [showModalBlueTooth, setShowModalBlueTooth] = useState(false);
  const [showModalBlueToothSPP, setShowModalBlueToothSPP] = useState(false);
  const [showModalMultiImpressao, setShowModalMultiImpressao] = useState(false);


  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    buscarImpressorasLocal();
    carregarConta();
  });

  function carregarConta() {

    const consultar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;

      requestService(empresaConfiguracoesCarregar.url.replace("{id}", id.replaceAll(/#/g, '%23')).concat("?filtro=", Buffer.from(loja).toString("base64")), {
        method: empresaConfiguracoesCarregar.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response);

          setImpressoraLargura(response.Item.impressoraLargura || '');

          //grava no localStorage
          const isLocalEnabled = window.localStorage.getItem("impressoraLocalHabilitar") === "true";
          setImpressoraLocalHabilitar(isLocalEnabled);
          setImpressoraLocalName(window.localStorage.getItem("impressoraLocalName") || "");

          //grava no DynamoDB (compartilhado entre dispositivos)
          setImpressoraRedeIp(response.Item.impressoraRedeIp || '');
          setImpressoraRedePorta(response.Item.impressoraRedePorta || '');

          //grava no localStorage (específico por dispositivo)
          const isRedeEnabled = window.localStorage.getItem("impressoraRedeHabilitar") === "true";
          setImpressoraRedeHabilitar(isRedeEnabled);

          //grava no localStorage
          const isBluetoothEnabled = window.localStorage.getItem("impressoraBluetoothHabilitar") === "true";
          setImpressoraBluetoothHabilitar(isBluetoothEnabled);
          setImpressoraBluetoothDeviceId(window.localStorage.getItem("impressoraBluetoothDeviceId") || "");
          setImpressoraBluetoothName(window.localStorage.getItem("impressoraBluetoothName") || "");

          // Bluetooth SPP (localStorage)
          const isBluetoothSPPEnabled = window.localStorage.getItem("impressoraBluetoothSPPHabilitar") === "true";
          setImpressoraBluetoothSPPHabilitar(isBluetoothSPPEnabled);
          setImpressoraBluetoothSPPAddress(window.localStorage.getItem("impressoraBluetoothSPPAddress") || "");
          setImpressoraBluetoothSPPName(window.localStorage.getItem("impressoraBluetoothSPPName") || "");

          setImpressaoAutomaticaIfood(response.Item.impressaoAutomaticaIfood || false);
          setImpressaoAutomatica(response.Item.impressaoAutomatica || false);
          setImpressaoDuasVias(response.Item.impressaoDuasVias || false);
          setMultiImpressao(response.Item.multiImpressao || 1);

          // Guarda as impressoras originais do banco
          setImpressorasAdicionaisOriginais(response.Item.impressorasAdicionais || []);

          // Detecta plataforma atual
          const isMobile = !isPlatform('mobileweb') && isPlatform('mobile');
          const isAndroid = isPlatform('android');

          // Função para converter estrutura flat antiga em aninhada
          const converterFlatParaAninhada = (impressorasFlat: any[]) => {
            // Verifica se já está no formato aninhado
            if (impressorasFlat.length > 0 && impressorasFlat[0].conexoes) {
              return impressorasFlat;
            }

            // Agrupa por nome
            const grupos: any = {};
            impressorasFlat.forEach((imp: any, index: number) => {
              const nome = imp.nome || `Impressora ${index + 2}`;

              if (!grupos[nome]) {
                grupos[nome] = {
                  nome: nome,
                  conexoes: []
                };
              }

              // Detectar tipo baseado nos campos preenchidos
              let tipoDetectado: 'local' | 'rede' | 'ble' | 'spp' | null = null;

              if (imp.tipo) {
                tipoDetectado = imp.tipo;
              } else {
                // Migração: detecta qual tipo está configurado
                if (imp.localName) {
                  tipoDetectado = 'local';
                } else if (imp.redeIp && imp.redePorta) {
                  tipoDetectado = 'rede';
                } else if (imp.bluetoothDeviceId) {
                  tipoDetectado = 'ble';
                } else if (imp.bluetoothSPPAddress) {
                  tipoDetectado = 'spp';
                }
              }

              if (tipoDetectado) {
                const conexao: any = {
                  tipo: tipoDetectado,
                  localName: tipoDetectado === 'local' ? (imp.localName || '') : '',
                  redeIp: tipoDetectado === 'rede' ? (imp.redeIp || '') : '',
                  redePorta: tipoDetectado === 'rede' ? (imp.redePorta || '') : '',
                  bluetoothDeviceId: tipoDetectado === 'ble' ? (imp.bluetoothDeviceId || '') : '',
                  bluetoothSPPAddress: tipoDetectado === 'spp' ? (imp.bluetoothSPPAddress || '') : '',
                };
                grupos[nome].conexoes.push(conexao);
              }
            });

            return Object.values(grupos);
          };

          const impressorasAninhadas: any[] = converterFlatParaAninhada(response.Item.impressorasAdicionais || []);

          // Filtra apenas conexões compatíveis com a plataforma atual
          const impressorasFiltradas = impressorasAninhadas.map((imp: any) => ({
            ...imp,
            conexoes: imp.conexoes.filter((con: any) => {
              if (isMobile) {
                // Mobile: mostra apenas rede, ble, spp (Android)
                if (con.tipo === 'rede' || con.tipo === 'ble') return true;
                if (con.tipo === 'spp' && isAndroid) return true;
                return false;
              } else {
                // Desktop: mostra apenas local
                return con.tipo === 'local';
              }
            })
          })).filter((imp: any) => imp.conexoes.length > 0); // Remove impressoras sem conexões compatíveis

          setImpressorasAdicionais(impressorasFiltradas);

          setImprimirMesaParcial(response.Item.imprimirMesaParcial || false);

          setTamanhoFonte(response.Item.tamanhoFonte || 'normal');

          setShowLoading(false);
        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    consultar();
  }

  const cadastrar = () => {
    setShowToast2(true);
  }

  function gerarEscPos(imprimir58mm: any = false, fonteGrande: boolean = false) {
    // Função para remover acentos e cedilhas
    function removerAcentosECedilha(texto: string): string {
      return texto
        .normalize('NFD')  // Normaliza o texto para decompô-lo em caracteres base e acentos
        .replace(/[\u0300-\u036f]/g, '')  // Remove os acentos
        .replace(/ç/g, 'c')  // Substitui 'ç' por 'c'
        .replace(/Ç/g, 'C');  // Substitui 'Ç' por 'C'
    }

    function gerarTexto() {
      let texto = "";

      texto += imprimir58mm ? `********************************\n` : `**************************************\n`;
      texto += `Conexão realizada com sucesso!\n`;
      texto += imprimir58mm ? `********************************\n` : `**************************************\n`;

      return texto;
    }

    try {


      console.log("dadosImpressao1");
      // Montando o cupom com os dados no formato ESC/POS
      const texto = gerarTexto();

      // Comandos ESC/POS básicos

      const ESC = 0x1B;  // ESC
      const GS = 0x1D;   // GS
      const LF = 0x0A;   // Line Feed
      const CORTA_PAPEL = [ESC, 0x69];   // Corta Papel
      const NEGRITO_ON = [ESC, 0x45, 0x01];  // Ativar negrito
      const NEGRITO_OFF = [ESC, 0x45, 0x00]; // Desativar negrito
      const ALIMENTAR_PAPEL = [ESC, 0x64, 0x10]; // Alimentação de papel
      const FONTE_NORMAL = [GS, 0x21, 0x00];
      const FONTE_GRANDE = [GS, 0x21, 0x01]; // Altura 2x, largura normal


      const dadosImpressao: any = [
        // ...ALIMENTAR_PAPEL, // Alimentação de papel
        LF,
        ...(fonteGrande ? FONTE_GRANDE : FONTE_NORMAL),

        ...removerAcentosECedilha(texto).split("").map(c => c.charCodeAt(0)),

        ...FONTE_NORMAL,
        LF, LF, LF, LF, LF,
        // ...ALIMENTAR_PAPEL, // Alimentação de papel
        ...CORTA_PAPEL

      ];

      // Retorna os dados como Uint8Array
      return new Uint8Array(dadosImpressao);
    } catch (error) {
      console.error('Erro ao imprimir cupom:', error);
      return null; // Retorna null em caso de erro
    }
  }

  async function closeModalModalBlueTooth() {
    setShowModalBlueTooth(false);
    setImpressoraAdicionalEmConfiguracao(null);
  }

  async function closeModalModalBlueToothSucess(deviceId: any, deviceName?: string) {
    setTextToast("Conectado ao dispositivo");
    setShowToast(true);

    // Verifica se está configurando uma impressora adicional
    if (impressoraAdicionalEmConfiguracao !== null) {
      const novasImpressoras = [...impressorasAdicionais];
      const conexaoIndex = (window as any).conexaoEmConfiguracaoIndex || 0;

      if (novasImpressoras[impressoraAdicionalEmConfiguracao]?.conexoes[conexaoIndex]) {
        novasImpressoras[impressoraAdicionalEmConfiguracao].conexoes[conexaoIndex].bluetoothDeviceId = deviceId;
        setImpressorasAdicionais(novasImpressoras);
      }
    } else {
      // Configuração da impressora principal
      setImpressoraBluetoothDeviceId(deviceId);
      setImpressoraBluetoothName(deviceName || '');
    }

    setShowModalBlueTooth(false);
    setImpressoraAdicionalEmConfiguracao(null);
    (window as any).conexaoEmConfiguracaoIndex = null;
  }

  // Modal Bluetooth SPP
  async function closeModalModalBlueToothSPP() {
    setShowModalBlueToothSPP(false);
  }

  async function closeModalModalBlueToothSPPSuccess(address: string, name: string) {
    setTextToast(`Conectado ao dispositivo: ${name}`);
    setShowToast(true);

    // Verifica se está configurando uma impressora adicional
    if (impressoraAdicionalEmConfiguracao !== null) {
      const novasImpressoras = [...impressorasAdicionais];
      const conexaoIndex = (window as any).conexaoEmConfiguracaoIndex || 0;

      if (novasImpressoras[impressoraAdicionalEmConfiguracao]?.conexoes[conexaoIndex]) {
        novasImpressoras[impressoraAdicionalEmConfiguracao].conexoes[conexaoIndex].bluetoothSPPAddress = address;
        setImpressorasAdicionais(novasImpressoras);
      }
    } else {
      // Configuração da impressora principal
      setImpressoraBluetoothSPPAddress(address);
      setImpressoraBluetoothSPPName(name);
    }

    setShowModalBlueToothSPP(false);
    setImpressoraAdicionalEmConfiguracao(null);
  }

  // Funções do Modal Multi Impressão
  const handleSaveMultiImpressao = (impressoras: any[]) => {
    console.log("impressoras salvas (estrutura aninhada):", impressoras);
    setImpressorasAdicionais(impressoras);
    // Conta total de conexões para multiImpressao
    const totalConexoes = impressoras.reduce((acc, imp) => acc + imp.conexoes.length, 0);
    setMultiImpressao(totalConexoes > 0 ? totalConexoes + 1 : 1);
  };

  const handleConfigurarBluetoothModal = (impressoraIndex: number, conexaoIndex: number, tipo: 'ble' | 'spp') => {
    // Armazena os índices para atualizar a conexão correta depois
    setImpressoraAdicionalEmConfiguracao(impressoraIndex);
    (window as any).conexaoEmConfiguracaoIndex = conexaoIndex;

    if (tipo === 'ble') {
      setShowModalBlueTooth(true);
    } else {
      setShowModalBlueToothSPP(true);
    }
  };

  const handleTestarImpressaoModal = async (conexao: any) => {
    console.log("Testando conexão:", conexao);

    if (conexao.tipo === 'local' && conexao.localName) {
      // Desktop - Impressora Local
      const comandosEscPos = gerarEscPos(impressoraLargura == "58" ? true : false, tamanhoFonte === "grande");
      if (comandosEscPos) {
        const resultadoString = converterParaString(comandosEscPos);
        await enviarImpressao(conexao.localName, resultadoString);
      }
    } else if (conexao.tipo === 'rede' && conexao.redeIp) {
      // Mobile - Impressora de Rede
      await testarImpressaoComFila('rede', {
        ip: conexao.redeIp,
        porta: parseInt(conexao.redePorta || '9100', 10)
      });
    } else if (conexao.tipo === 'ble' && conexao.bluetoothDeviceId) {
      // Mobile - Bluetooth BLE
      await testarImpressaoComFila('ble', {
        deviceId: conexao.bluetoothDeviceId
      });
    } else if (conexao.tipo === 'spp' && conexao.bluetoothSPPAddress) {
      // Android - Bluetooth SPP
      await testarImpressaoComFila('spp', {
        address: conexao.bluetoothSPPAddress
      });
    }
  };


  // Função para buscar impressoras
  const buscarImpressorasLocal = async () => {
    const url = "http://localhost:9100";

    try {
      const requestOptions: any = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        redirect: "follow",
      };

      const resp = await fetch(url, requestOptions);
      const result = await resp.json(); // Supondo que o retorno é um JSON com uma lista de impressoras

      console.log("result", result);
      if (result && Array.isArray(result)) {
        setImpressorasLocal(result);
      }
      // if (result && Array.isArray(result)) {
      //   // Adiciona a opção "Nenhum" no início da lista
      //   const impressorasComNenhum = [{ Name: '' }, ...result];
      //   setImpressorasLocal(impressorasComNenhum); // Define as impressoras no estado
      // } else {
      //   console.error("Erro: Nenhuma resposta válida recebida.");
      // }
    } catch (error) {
      console.error("Erro ao obter dados:", error);
    }
  };


  function converterParaString(dadosImpressao: any) {
    return String.fromCharCode(...dadosImpressao.filter((byte: any) => byte <= 0xFF)); // Filtrando valores válidos
  }

  async function enviarImpressao(printer: any, data: any) {

    const url = "http://localhost:9100/print";

    // Montando o corpo da requisição no formato necessário
    var raw = JSON.stringify({
      "printer": printer,
      "data": data,  // Dados no formato correto (com códigos ESC/POS)
    });

    try {
      // Configurações da requisição
      const requestOptions: any = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: 'follow',
      };

      // Envia a requisição utilizando fetch
      const resp = await fetch(url, requestOptions);

      // Aguardar a resposta como texto
      const result = await resp.text();

      if (result) {
        console.log("Impressão enviada com sucesso:", result);
      } else {
        console.error("Erro: Nenhuma resposta recebida.");
      }
    } catch (error) {
      console.error("Erro ao enviar dados para a impressora:", error);
    }
  }

  // ============= Bluetooth SPP (Serial Port Profile) - Somente Android =============

  async function imprimirBluetoothSPP(comandosEscPos: Uint8Array) {
    try {
      setShowLoading(true);

      if (!impressoraBluetoothSPPAddress) {
        throw new Error('Nenhum dispositivo configurado.');
      }

      // Verifica se já está conectado
      let isConnected = false;
      try {
        isConnected = await BluetoothSerial.isConnected();
        console.log('Estado inicial da conexão SPP:', isConnected ? 'CONECTADO' : 'DESCONECTADO');
      } catch (checkError) {
        console.log('Não conectado (isConnected falhou):', checkError);
        isConnected = false;
      }

      if (!isConnected) {
        // Conecta ao dispositivo com subscribe para monitorar conexão
        console.log('Iniciando conexão SPP com:', impressoraBluetoothSPPAddress);

        await new Promise<void>((resolve, reject) => {
          let connectionTimeout: any;

          // Subscribe para receber dados (indica que conectou)
          BluetoothSerial.subscribe('\n').subscribe(
            (data) => {
              console.log('Subscribe SPP recebeu dados:', data);
            },
            (error) => {
              console.log('Erro no subscribe SPP:', error);
            }
          );

          // Timeout de 10 segundos para conectar
          connectionTimeout = setTimeout(() => {
            BluetoothSerial.disconnect();
            reject(new Error('Timeout: não foi possível conectar à impressora em 10 segundos. Verifique se a impressora está ligada e próxima.'));
          }, 10000);

          // Tenta conectar
          BluetoothSerial.connect(impressoraBluetoothSPPAddress).subscribe(
            async () => {
              clearTimeout(connectionTimeout);
              console.log('Callback de conexão SPP executado!');

              // Aguarda estabilização
              await new Promise(r => setTimeout(r, 1500));

              try {
                // Verifica se está conectado
                const isNowConnected = await BluetoothSerial.isConnected();
                console.log('Estado após conectar SPP:', isNowConnected ? 'CONECTADO' : 'DESCONECTADO');

                if (!isNowConnected) {
                  throw new Error('Impressora não conectou. Verifique se está ligada e tente novamente.');
                }

                resolve();
              } catch (err) {
                reject(err);
              }
            },
            (error) => {
              clearTimeout(connectionTimeout);
              console.error('Erro ao conectar SPP:', error);
              reject(new Error(`Falha na conexão: ${error}. Verifique se a impressora está pareada e ligada.`));
            }
          );
        });
      } else {
        console.log('SPP já conectado, reutilizando conexão existente');
      }

      // Converte Uint8Array para string
      const dataString = Array.from(comandosEscPos)
        .map(byte => String.fromCharCode(byte))
        .join('');

      // Envia os dados (conexão já está ativa)
      console.log('Enviando', comandosEscPos.length, 'bytes para a impressora SPP...');
      await BluetoothSerial.write(dataString);
      console.log('Dados SPP enviados com sucesso!');

      // Aguarda processamento
      await new Promise(r => setTimeout(r, 500));

      setTextToast("Impressão realizada com sucesso!");
      setShowToast(true);
      setShowLoading(false);

    } catch (error: any) {
      console.error('Erro ao imprimir via Bluetooth SPP:', error);
      setTextToast(error.message || `Erro: ${error}`);
      setShowToast(true);
      setShowLoading(false);

      // NÃO desconecta em caso de erro - mantém conexão para próximas tentativas
    }
  }

  // ============= FUNÇÃO DE TESTE COM SISTEMA DE FILA =============

  async function testarImpressaoComFila(tipo: 'ble' | 'spp' | 'rede' | 'local', config: any) {
    const comandosEscPos = gerarEscPos(impressoraLargura == "58" ? true : false, tamanhoFonte === "grande");

    if (!comandosEscPos) {
      console.error('Erro ao gerar ESC/POS');
      setTextToast("Erro ao gerar comandos de impressão.");
      setShowToast(true);
      return;
    }

    const adicionado = adicionarImpressaoNaFila(criarJobImpressao({
      comandosEscPos,
      dados: { teste: true, tipo },
      impressoraConfig: config,
      tipo,
      quantidadeVias: 1,
      origem: 'Impressao:testarConexao'
    }));

    if (adicionado) {
      console.log(`📋 [TESTE] Teste de impressão ${tipo} adicionado na fila`);
      setTextToast("Teste adicionado na fila de impressão!");
      setShowToast(true);
    } else {
      setTextToast("Erro ao adicionar teste na fila.");
      setShowToast(true);
    }
  }

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">


          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack(); }}><IonIcon slot="icon-only" icon={arrowBack} /></IonButton>
          </IonButtons>


          <IonTitle slot="start">Impressão</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <OnboardingContextBanner />
        <IonList>






          <IonItem lines="full">
            <IonLabel color="primary">Configuração impressora</IonLabel>
          </IonItem>

          <IonItem lines="none">
            <IonLabel position="stacked">Largura</IonLabel>
            <IonSelect disabled={acessos?.configuracoes != 'edicao'}
              value={impressoraLargura}
              placeholder="Selecione uma impressora"
              onIonChange={(e) => setImpressoraLargura(e.detail.value)}
            >
              <IonSelectOption key="largura80mm" value="80">
                80mm
              </IonSelectOption>
              <IonSelectOption key="largura58mm" value="58">
                58mm
              </IonSelectOption>
            </IonSelect>
          </IonItem>

          <IonItem lines="none">
            <IonLabel position="stacked">Tamanho da fonte</IonLabel>
            <IonSelect disabled={acessos?.configuracoes != 'edicao'}
              value={tamanhoFonte}
              placeholder="Selecione o tamanho"
              onIonChange={(e) => setTamanhoFonte(e.detail.value)}
            >
              <IonSelectOption key="fonteNormal" value="normal">
                Normal
              </IonSelectOption>
              <IonSelectOption key="fonteGrande" value="grande">
                Grande (altura maior)
              </IonSelectOption>
            </IonSelect>
          </IonItem>

          <IonItem lines="none">
            <IonLabel>Impressão fechar Balcão/{(window.localStorage.getItem("nomeInternoMesasOuComandas") || "Mesas")}</IonLabel>

            <IonToggle slot="end" disabled={acessos?.configuracoes != 'edicao'}
              checked={impressaoAutomatica}
              onIonChange={(e: any) => {
                const isChecked = e.detail.checked;
                setImpressaoAutomatica(isChecked);
                // window.localStorage.setItem("impressoraLocalHabilitar", isChecked ? "true" : "false");
              }}
            />
          </IonItem>

          <IonItem lines="none">
            <IonLabel>Impressão parcial {(window.localStorage.getItem("nomeInternoMesasOuComandas") || "Mesas")}</IonLabel>

            <IonToggle slot="end" disabled={acessos?.configuracoes != 'edicao'}
              checked={imprimirMesaParcial}
              onIonChange={(e: any) => setImprimirMesaParcial(e.detail.checked)}
            />
          </IonItem>

          <IonItem lines="none">
            <IonLabel>Impressão automática {(window.localStorage.getItem("servicoTipoPlural") || "Projetos")}</IonLabel>

            <IonToggle slot="end" disabled={acessos?.configuracoes != 'edicao'}
              checked={impressaoAutomaticaIfood}
              onIonChange={(e: any) => {
                const isChecked = e.detail.checked;
                setImpressaoAutomaticaIfood(isChecked);
                // window.localStorage.setItem("impressoraLocalHabilitar", isChecked ? "true" : "false");
              }}
            />
          </IonItem>

          <IonItem lines="none">
            <IonLabel>Impressão duas vias</IonLabel>

            <IonToggle slot="end" disabled={acessos?.configuracoes != 'edicao'}
              checked={impressaoDuasVias}
              onIonChange={(e: any) => {
                const isChecked = e.detail.checked;
                setImpressaoDuasVias(isChecked);
              }}
            />
          </IonItem>


          <IonItem lines="full" hidden={(!isPlatform('mobileweb') && isPlatform('mobile'))} >
            <IonLabel color="primary">Impressora local (<a target='_blank' href="https://xeguei.com.br/impressao.html">Instale o módulo de impressão</a>)</IonLabel>
          </IonItem>

          <IonItem lines="none" hidden={(!isPlatform('mobileweb') && isPlatform('mobile'))} >
            <IonLabel>Habilitar</IonLabel>

            <IonToggle slot="end"
              checked={impressoraLocalHabilitar}
              onIonChange={(e: any) => {
                const isChecked = e.detail.checked;
                setImpressoraLocalHabilitar(isChecked);

                if (isChecked) {
                  // Desmarca todas as outras impressoras
                  setImpressoraBluetoothHabilitar(false);
                  setImpressoraBluetoothSPPHabilitar(false);
                  setImpressoraRedeHabilitar(false);

                  // Remove do localStorage as outras impressoras
                  window.localStorage.removeItem("impressoraBluetoothHabilitar");
                  window.localStorage.removeItem("impressoraBluetoothSPPHabilitar");
                  window.localStorage.removeItem("impressoraRedeHabilitar");
                }
                else {
                  setImpressoraLocalName("");
                }
                // Quando desabilita, não remove nada - deixa as configs salvas
              }}
            />
          </IonItem>


          <IonItem lines="none" hidden={(!isPlatform('mobileweb') && isPlatform('mobile'))} >
            <IonLabel position="stacked">Nome da impressora</IonLabel>
            <IonSelect
              value={impressoraLocalName}
              placeholder="Selecione uma impressora"
              onIonChange={(e) => setImpressoraLocalName(e.detail.value)}
            >
              {impressorasLocal?.map((impressora: any, index: any) => (
                <IonSelectOption key={index} value={impressora.Name}>
                  {impressora.Name}
                </IonSelectOption>
              ))}
            </IonSelect>
          </IonItem>

          {/* <IonItem lines="none" hidden={(!isPlatform('mobileweb') && isPlatform('mobile'))} >
            <IonButton size="large" slot="end" onClick={buscarImpressorasLocal}>Buscar impressoras</IonButton>
          </IonItem> */}


          <IonItem lines="none" hidden={(!isPlatform('mobileweb') && isPlatform('mobile'))} >

            <IonButton size="large" slot="end" onClick={async () => {
              if (!(!isPlatform('mobileweb') && isPlatform('mobile'))) {
                // Usa o sistema de fila de impressão
                await testarImpressaoComFila('local', {
                  printerName: impressoraLocalName
                });
              }
              else {
                setTextToast("Essa funcionalidade é somente para computadores.");
                setShowToast(true);
              }
            }}>Testar conexão</IonButton>
          </IonItem>

          <IonItem lines="full" hidden={!(!isPlatform('mobileweb') && isPlatform('mobile'))} >
            <IonLabel color="primary">Impressora Bluetooth BLE</IonLabel>
          </IonItem>

          <IonItem lines="none" hidden={!(!isPlatform('mobileweb') && isPlatform('mobile'))} >
            <IonLabel>Habilitar</IonLabel>

            <IonToggle slot="end"
              checked={impressoraBluetoothHabilitar}
              onIonChange={(e: any) => {
                const isChecked = e.detail.checked;
                setImpressoraBluetoothHabilitar(isChecked);

                if (isChecked) {
                  // Desmarca todas as outras impressoras
                  setImpressoraLocalHabilitar(false);
                  setImpressoraBluetoothSPPHabilitar(false);
                  setImpressoraRedeHabilitar(false);

                  // Remove do localStorage as outras impressoras
                  window.localStorage.removeItem("impressoraLocalHabilitar");
                  window.localStorage.removeItem("impressoraBluetoothSPPHabilitar");
                  window.localStorage.removeItem("impressoraRedeHabilitar");
                }
                else {
                  setImpressoraBluetoothDeviceId("");
                  setImpressoraBluetoothName("");
                }
              }}
            />
          </IonItem>

          <IonItem lines="none" hidden={!(!isPlatform('mobileweb') && isPlatform('mobile'))} >
            <IonLabel position="stacked">Dispositivo Bluetooth</IonLabel>
            <div style={{ background: "#eeeeee", borderRadius: "5px", padding: "10px", marginTop: "10px", width: "100%" }}>
              {impressoraBluetoothName ? (
                <div>
                  <strong>{impressoraBluetoothName}</strong><br />
                  <span style={{ fontSize: '0.9em', color: '#666' }}>{impressoraBluetoothDeviceId}</span>
                </div>
              ) : (
                <span style={{ color: '#999' }}>Nenhum dispositivo configurado</span>
              )}
            </div>
          </IonItem>

          <IonItem lines="none" hidden={!(!isPlatform('mobileweb') && isPlatform('mobile'))} >
            <IonButton size="large" slot="end" onClick={() => {
              if (!isPlatform('mobileweb') && isPlatform('mobile')) {
                setImpressoraAdicionalEmConfiguracao(null);
                setShowModalBlueTooth(true);
              }
              else {
                setTextToast("Essa funcionalidade é somente para celulares e tablets.");
                setShowToast(true);
              }
            }}>
              Configurar
            </IonButton>

            <IonButton size="large" slot="end"
              disabled={!impressoraBluetoothDeviceId}
              onClick={async () => {
                if (!isPlatform('mobileweb') && isPlatform('mobile')) {
                  // Usa o sistema de fila de impressão
                  await testarImpressaoComFila('ble', {
                    deviceId: impressoraBluetoothDeviceId
                  });
                }
                else {
                  setTextToast("Essa funcionalidade é somente para celulares e tablets.");
                  setShowToast(true);
                }
              }}>
              Testar conexão
            </IonButton>
          </IonItem>

          {/* ============= Bluetooth SPP (Serial Port Profile) - Somente Android ============= */}
          <IonItem lines="full" hidden={!isPlatform('android')} >
            <IonLabel color="primary">Impressora Bluetooth SPP (Android)</IonLabel>
          </IonItem>

          <IonItem lines="none" hidden={!isPlatform('android')} >
            <IonLabel>Habilitar</IonLabel>

            <IonToggle slot="end"
              checked={impressoraBluetoothSPPHabilitar}
              onIonChange={(e: any) => {
                const isChecked = e.detail.checked;
                setImpressoraBluetoothSPPHabilitar(isChecked);

                if (isChecked) {
                  // Desmarca todas as outras impressoras
                  setImpressoraLocalHabilitar(false);
                  setImpressoraBluetoothHabilitar(false);
                  setImpressoraRedeHabilitar(false);

                  // Remove do localStorage as outras impressoras
                  window.localStorage.removeItem("impressoraLocalHabilitar");
                  window.localStorage.removeItem("impressoraBluetoothHabilitar");
                  window.localStorage.removeItem("impressoraRedeHabilitar");
                }
                else {
                  setImpressoraBluetoothSPPAddress("");
                  setImpressoraBluetoothSPPName("");
                }
              }}
            />
          </IonItem>

          <IonItem lines="none" hidden={!isPlatform('android')} >
            <IonLabel position="stacked">Dispositivo Bluetooth</IonLabel>
            <div style={{ background: "#eeeeee", borderRadius: "5px", padding: "10px", marginTop: "10px", width: "100%" }}>
              {impressoraBluetoothSPPName ? (
                <div>
                  <strong>{impressoraBluetoothSPPName}</strong><br />
                  <span style={{ fontSize: '0.9em', color: '#666' }}>{impressoraBluetoothSPPAddress}</span>
                </div>
              ) : (
                <span style={{ color: '#999' }}>Nenhum dispositivo configurado</span>
              )}
            </div>
          </IonItem>

          <IonItem lines="none" hidden={!isPlatform('android')} >
            <IonButton size="large" slot="end" onClick={() => {
              if (isPlatform('android')) {
                setShowModalBlueToothSPP(true);
              } else {
                setTextToast("Essa funcionalidade é somente para Android.");
                setShowToast(true);
              }
            }}>
              Configurar
            </IonButton>

            <IonButton size="large" slot="end"
              disabled={!impressoraBluetoothSPPAddress}
              onClick={async () => {
                if (isPlatform('android')) {
                  // Usa o sistema de fila de impressão
                  await testarImpressaoComFila('spp', {
                    address: impressoraBluetoothSPPAddress
                  });
                } else {
                  setTextToast("Essa funcionalidade é somente para Android.");
                  setShowToast(true);
                }
              }}>
              Testar conexão
            </IonButton>
          </IonItem>

          <IonItem lines="full" hidden={!(!isPlatform('mobileweb') && isPlatform('mobile'))} >
            <IonLabel color="primary">Impressora de rede</IonLabel>
          </IonItem>

          <IonItem lines="none" hidden={!(!isPlatform('mobileweb') && isPlatform('mobile'))} >
            <IonLabel>Habilitar</IonLabel>

            <IonToggle slot="end"
              checked={impressoraRedeHabilitar}
              onIonChange={(e: any) => {
                const isChecked = e.detail.checked;
                setImpressoraRedeHabilitar(isChecked);

                if (isChecked) {
                  // Desmarca todas as outras impressoras
                  setImpressoraLocalHabilitar(false);
                  setImpressoraBluetoothHabilitar(false);
                  setImpressoraBluetoothSPPHabilitar(false);

                  // Remove do localStorage as outras impressoras
                  window.localStorage.removeItem("impressoraLocalHabilitar");
                  window.localStorage.removeItem("impressoraBluetoothHabilitar");
                  window.localStorage.removeItem("impressoraBluetoothSPPHabilitar");
                }
                else {
                  setImpressoraRedeIp("");
                  setImpressoraRedePorta("");
                }
              }}
            />
          </IonItem>


          <IonItem lines="none" hidden={!(!isPlatform('mobileweb') && isPlatform('mobile'))} >
            <IonLabel position="stacked">IP</IonLabel>
            <div style={{ background: "#eeeeee", borderRadius: "5px", padding: "10px", marginTop: "10px", width: "100%" }}>
              <IonInput
                type="text"
                value={impressoraRedeIp}
                maxlength={15}
                placeholder="IP da impressora"
                onIonInput={(e: any) => setImpressoraRedeIp(e.target.value)}
                style={{ width: "100%" }}
              />
            </div>
          </IonItem>

          <IonItem lines="none" hidden={!(!isPlatform('mobileweb') && isPlatform('mobile'))} >
            <IonLabel position="stacked">Porta (9100)</IonLabel>
            <div style={{ background: "#eeeeee", borderRadius: "5px", padding: "10px", marginTop: "10px", width: "100%" }}>
              <IonInput
                type="text"
                value={impressoraRedePorta}
                maxlength={15}
                placeholder="Porta da impressora"
                onIonInput={(e: any) => setImpressoraRedePorta(e.target.value)}
                style={{ width: "100%" }}
              />
            </div>
          </IonItem>




          <IonItem lines="none" hidden={!(!isPlatform('mobileweb') && isPlatform('mobile'))} >
            <IonButton size="large" slot="end" onClick={async () => {

              if (!isPlatform('mobileweb') && isPlatform('mobile')) {
                // Usa o sistema de fila de impressão
                await testarImpressaoComFila('rede', {
                  ip: impressoraRedeIp,
                  porta: parseInt(impressoraRedePorta, 10)
                });
              }
              else {
                setTextToast("Essa funcionalidade é somente para celulares e tablets.");
                setShowToast(true);
              }

            }}>Testar conexão</IonButton>
          </IonItem>





          <IonItem lines="full">
            <IonLabel color="primary">Multi Impressão</IonLabel>
          </IonItem>

          <IonItem lines="none">
            <IonLabel>
              <p style={{ fontSize: '0.9em', color: '#666' }}>
                {impressorasAdicionais.length > 0
                  ? `${impressorasAdicionais.length} impressora(s) com ${impressorasAdicionais.reduce((acc, imp) => acc + imp.conexoes.length, 0)} conexão(ões) configurada(s)`
                  : 'Nenhuma impressora adicional configurada'}
              </p>
            </IonLabel>
          </IonItem>

          <IonItem lines="none">
            <IonButton disabled={acessos?.configuracoes != 'edicao'} size="large" slot="end" onClick={() => setShowModalMultiImpressao(true)}>
              Configurar
            </IonButton>
          </IonItem>


          {/* <IonItem lines="full">
            <IonLabel color="primary">iFood</IonLabel>
          </IonItem>

          <IonItem lines="none">
            <IonLabel>Impressão automática de pedidos</IonLabel>

            <IonToggle slot="end"
              checked={impressaoAutomaticaIfood}
              onIonChange={(e: any) => {
                const isChecked = e.detail.checked;
                setImpressaoAutomaticaIfood(isChecked);
                // window.localStorage.setItem("impressoraLocalHabilitar", isChecked ? "true" : "false");
              }}
            />
          </IonItem> */}

          {/* <IonItem lines="none">
            <IonButton size="large" slot="end" onClick={() => {
              getUserCode();
              setAtivarIfood1(true);
            }}>Ativar</IonButton>

            <IonButton size="large" slot="end" onClick={() => {
              getMerchants();
            }}>Detalhes</IonButton> */}
          {/* <IonButton size="large" slot="end" onClick={() => {
              try {
                console.log("getEvents loja", loja);
                const id = loja.replace(/#/g, '%23'); // Escapa o ID da loja

                requestService(
                  apiIfoodEvents.url.replace("{id}", id),
                  {
                    method: apiIfoodEvents.method,
                    headers: [["token", window.localStorage.getItem("token")]],
                    credentials: 'include',
                  },
                  history,
                  (response: any) => {
                    console.log(response);

                    if (response) {

                      Toast.show({
                        text: "Integrado com sucesso.",
                        position: "center",
                        duration: "long"
                      });

                    }
                  },
                  (error: any) => {
                    console.log(error);
                    if (error.message) {
                      Toast.show({
                        text: error.message,
                        position: "center",
                        duration: "long"
                      });
                    }
                  }
                );
              } catch (error) {
                console.error("Integração não foi realizada.", error);
              }
            }}>Validar integração</IonButton> */}
          {/* </IonItem> */}

          {/* <IonItem lines="full">
            <IonLabel color="primary">Cadastro</IonLabel>
          </IonItem>
          <IonItem lines="none">
            <IonLabel>Enviar mensagem para o Cliente</IonLabel>
            <IonToggle slot="end"
              checked={enviarMsgClienteCadastro.S === "sim"}
              onIonChange={(e: any) => setEnviarMsgClienteCadastro({ S: e.detail.checked ? "sim" : "não" })}
            />
          </IonItem> */}

          {/* 
          <IonItem lines="full">
            <IonLabel color="primary">Integração Mercado Pago - Point</IonLabel>
          </IonItem>

          <IonItem lines="none">
            <IonButton size="large" slot="end" onClick={() => {
              setMercadoPago1(true);
            }}>Ativar</IonButton>

            <IonButton size="large" slot="end" onClick={() => {
              getDevices();
            }}>Detalhes</IonButton>
          </IonItem> */}









        </IonList>
        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonAlert isOpen={showToast2}
          onDidDismiss={() => setShowToast2(false)}
          header={'Alterar configurações'}
          message={'Você <strong>confirma</strong> a alteração?'}
          buttons={[
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Confirmar',
              cssClass: 'primary',
              handler: () => {

                setShowLoading(true);

                window.localStorage.setItem("impressoraLocalHabilitar", impressoraLocalHabilitar ? "true" : "false");
                window.localStorage.setItem("impressoraLocalName", impressoraLocalName);

                window.localStorage.setItem("impressoraRedeHabilitar", impressoraRedeHabilitar ? "true" : "false");

                window.localStorage.setItem("impressoraBluetoothHabilitar", impressoraBluetoothHabilitar ? "true" : "false");
                window.localStorage.setItem("impressoraBluetoothDeviceId", impressoraBluetoothDeviceId);
                window.localStorage.setItem("impressoraBluetoothName", impressoraBluetoothName);

                // Bluetooth SPP
                window.localStorage.setItem("impressoraBluetoothSPPHabilitar", impressoraBluetoothSPPHabilitar ? "true" : "false");
                window.localStorage.setItem("impressoraBluetoothSPPAddress", impressoraBluetoothSPPAddress);
                window.localStorage.setItem("impressoraBluetoothSPPName", impressoraBluetoothSPPName);

                // Mescla as impressoras adicionais: mantém estrutura aninhada
                const impressorasMescladas: any[] = [];

                // Detecta plataforma atual
                const isMobile = !isPlatform('mobileweb') && isPlatform('mobile');
                const isAndroid = isPlatform('android');

                // Tipos compatíveis com a plataforma atual
                const tiposPlataformaAtual = isMobile
                  ? ['rede', 'ble', ...(isAndroid ? ['spp'] : [])]
                  : ['local'];

                // 1. Carrega impressoras do banco e converte flat para aninhado se necessário
                const impressorasOriginaisAninhadas: any[] = [];

                impressorasAdicionaisOriginais.forEach((item: any) => {
                  if (item.conexoes) {
                    // Já está no formato aninhado
                    impressorasOriginaisAninhadas.push(item);
                  } else {
                    // Formato flat antigo - converter para aninhado
                    const impressoraExistente = impressorasOriginaisAninhadas.find(imp => imp.nome === item.nome);

                    if (impressoraExistente) {
                      // Adiciona conexão à impressora existente
                      impressoraExistente.conexoes.push({
                        tipo: item.tipo,
                        localName: item.localName || '',
                        redeIp: item.redeIp || '',
                        redePorta: item.redePorta || '',
                        bluetoothDeviceId: item.bluetoothDeviceId || '',
                        bluetoothSPPAddress: item.bluetoothSPPAddress || '',
                      });
                    } else {
                      // Cria nova impressora
                      impressorasOriginaisAninhadas.push({
                        nome: item.nome,
                        conexoes: [{
                          tipo: item.tipo,
                          localName: item.localName || '',
                          redeIp: item.redeIp || '',
                          redePorta: item.redePorta || '',
                          bluetoothDeviceId: item.bluetoothDeviceId || '',
                          bluetoothSPPAddress: item.bluetoothSPPAddress || '',
                        }]
                      });
                    }
                  }
                });

                // 2. Para cada impressora do banco, remove conexões da plataforma atual e mantém as outras
                impressorasOriginaisAninhadas.forEach((impressoraOriginal: any) => {
                  const conexoesOutrasPlataformas = impressoraOriginal.conexoes.filter((conexao: any) => {
                    return !tiposPlataformaAtual.includes(conexao.tipo);
                  });

                  if (conexoesOutrasPlataformas.length > 0) {
                    impressorasMescladas.push({
                      nome: impressoraOriginal.nome,
                      conexoes: conexoesOutrasPlataformas
                    });
                  }
                });

                // 3. Mescla impressoras locais (da plataforma atual)
                impressorasAdicionais.forEach((impressoraLocal: any) => {
                  // Verifica se já existe no array mesclado (outras plataformas)
                  const impressoraExistente = impressorasMescladas.find(imp => imp.nome === impressoraLocal.nome);

                  if (impressoraExistente) {
                    // Adiciona conexões da plataforma atual
                    impressoraExistente.conexoes.push(...impressoraLocal.conexoes);
                  } else {
                    // Cria nova entrada
                    impressorasMescladas.push({
                      nome: impressoraLocal.nome,
                      conexoes: [...impressoraLocal.conexoes]
                    });
                  }
                });

                console.log("Impressoras mescladas (aninhadas):", impressorasMescladas);

                const objectRequest = {

                  impressoraLargura,
                  impressoraRedeIp,
                  impressoraRedePorta: impressoraRedePorta ? parseInt(impressoraRedePorta, 10) : 0,
                  impressaoAutomaticaIfood,
                  impressaoAutomatica,
                  impressaoDuasVias,
                  multiImpressao,
                  impressorasAdicionais: impressorasMescladas,
                  imprimirMesaParcial,
                  tamanhoFonte,

                };
                let id = loja;

                console.log("id", id)

                requestService(
                  empresaAlterar.url.replace("{id}", id.replaceAll("#", "%23")).concat("?tipo=impressao"),
                  {
                    method: empresaAlterar.method,
                    body: JSON.stringify(objectRequest),
                    headers: [
                      ["token", window.localStorage.getItem("token")]
                    ],
                    credentials: 'include'
                  },
                  history,
                  (response: any) => {
                    console.log(response);
                    if (response) {
                      setTextToast("Alteração realizado com sucesso.");
                      setShowSucesso(true);

                      // Marcar etapa do onboarding como concluída
                      if (onboardingData && !onboardingData.onboarding_concluido) {
                        const urlOnb = onboardingAtualizarEtapa.url
                          .replace("{empresa_id}", onboardingData.empresa_id.replaceAll("#", "%23"));
                        requestService(urlOnb, {
                          method: onboardingAtualizarEtapa.method,
                          body: JSON.stringify({ etapa_id: 'impressao', status: 'concluido' }),
                          headers: [["token", window.localStorage.getItem("token")]],
                          credentials: 'include'
                        }, history, (r: any) => { if (r) setOnboardingData(r); }, () => { });
                      }

                    } else if (response.status === 400) {
                      console.log(response);
                      setTextToast("Ocorreu um erro ao efetuar a alteração.");
                      setShowToast(true);

                    }
                    setShowLoading(false);
                  },
                  (error: any) => {
                    console.log(error);
                    setTextToast("Ocorreu um erro ao efetuar a alteração.");
                    setShowToast(true);
                    setShowLoading(false);
                  })
              }
            }
          ]}
        />

        {/* <IonModal isOpen={(Array.isArray(listaEnderecos) && listaEnderecos.length > 0)} onDidDismiss={() => { setListaEnderecos([]); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Selecione um endereço</IonTitle>
              <IonButtons slot="start" onClick={() => setListaEnderecos([])}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonList>
              {readListaEnderecos()}
            </IonList>
          </IonContent>
          <IonFooter>
            <IonButton expand="block" color="primary" onClick={(e) => {

              mostartAlerta({
                backdropDismiss: false,
                header: 'Número e complemento',
                message: 'Adicione número e complemento',
                inputs: [
                  {
                    name: 'mensagem',
                    type: 'textarea',
                    id: 'name2-id',
                    placeholder: 'Digite aqui o número e complemento',
                  }],
                buttons: ['Cancel', {
                  text: 'OK', handler: (d) => {
                    setEmpresaEndereco(empresaEndereco + ", " + d.mensagem);
                    // todo: precisa trocar para utilizar da propria lista
                    buscarLocalizacao(localEnderecoSelecionado + ", " + d.mensagem);
                  }
                }],
                onDidDismiss: (e) => { console.log('did dismiss'); }
              })

              setListaEnderecos([]);
            }}>Avançar</IonButton>
          </IonFooter>
        </IonModal> */}

        <IonModal isOpen={showModalBlueTooth} onDidDismiss={() => { setShowModalBlueTooth(false); }}>
          <Bluetooth closeAction={closeModalModalBlueToothSucess} closeActionSimple={closeModalModalBlueTooth}></Bluetooth>
        </IonModal>

        <IonModal isOpen={showModalBlueToothSPP} onDidDismiss={() => { setShowModalBlueToothSPP(false); }}>
          <BluetoothSPP closeAction={closeModalModalBlueToothSPPSuccess} closeActionSimple={closeModalModalBlueToothSPP}></BluetoothSPP>
        </IonModal>

        <ModalMultiImpressao
          isOpen={showModalMultiImpressao}
          onClose={() => setShowModalMultiImpressao(false)}
          onSave={handleSaveMultiImpressao}
          impressorasIniciais={impressorasAdicionais}
          impressorasLocal={impressorasLocal}
          onConfigurarBluetooth={handleConfigurarBluetoothModal}
          onTestarImpressao={handleTestarImpressaoModal}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showSucesso}
          onDidDismiss={(e: any) => { setShowSucesso(false); history.goBack(); }}
          message={'Alterações salvas com sucesso!'}
          duration={3000}
          animated={false}
        />
      </IonContent >
      <IonFooter className="ion-no-border">
        <IonToolbar>
          <IonButton onClick={() => cadastrar()} expand="block" type="submit">Salvar</IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage >
  );
};

export default Impressao;
